import paper from "paper"
import {auditTime, BehaviorSubject, merge} from "rxjs"
import {Vector2} from "@cm/math"
import {TilingCanvasToolboxItemBase} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/tiling-canvas-toolbox-item-base"
import {CanvasToolboxItemBase} from "@common/helpers/canvas/canvas-toolbox/canvas-toolbox-item-base"

export class LabelToolboxItem extends TilingCanvasToolboxItemBase {
    readonly position$ = new BehaviorSubject(new Vector2())
    readonly text$ = new BehaviorSubject("")
    readonly angle$ = new BehaviorSubject(0)
    readonly screenSpaceOffset$ = new BehaviorSubject(new Vector2())

    constructor(parent: CanvasToolboxItemBase) {
        super(parent)
        this.label = new paper.PointText(new paper.Point(0, 0))
        this.label.fillColor = new paper.Color("white")
        this.label.justification = "center"
        this.label.fontSize = this.baseFontSize
        this.label.strokeColor = new paper.Color("black")
        this.label.strokeWidth = this.baseFontStrokeWidth / this.callback.zoomLevel
        this.label.fontFamily = "Roboto"
        this.label.fontWeight = "Bold"
        this.label.fillColor = new paper.Color("white")
        this.updateLabel()

        merge(this.position$, this.text$, this.angle$)
            .pipe(auditTime(0))
            .subscribe(() => this.updateLabel())
        merge(this.callback.viewChange, this.screenSpaceOffset$).subscribe(() => this.updateZoomDependent())
    }

    private updateLabel(): void {
        this.label.content = this.text$.value
        this.label.rotation = this.angle$.value
        this.updateZoomDependent()
    }

    private updateZoomDependent() {
        const zoomLevel = this.callback.zoomLevel
        this.label.fontSize = this.baseFontSize / zoomLevel
        this.label.strokeWidth = this.baseFontStrokeWidth / zoomLevel
        this.label.position.set(this.position$.value.add(this.screenSpaceOffset$.value.div(zoomLevel)))
    }

    private label!: paper.PointText
    private baseFontStrokeWidth = 0.75
    readonly baseFontSize = 18
}
